import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";

export interface EventData{
    name: string,
    description?: string,
    startDate: string,
    endDate?: string,
    location: EventLocationData,
    images: Array<string>,
    companyName: string,
    companyUrl: string,
	minPrice?: string,
	eventUrl: string
}

export interface EventLocationData{
    name: string,
    streetAddress: string,
    addressLocality: string,
    postalCode?: string,
    addressRegion: string,
    addressCountry?: string,
}

@Injectable({
	providedIn: 'root'
})

export class JsonLDService {
	static scriptType = 'application/ld+json';
 
    eventSchema = (event: EventData ) => {
		var schema:any =  {
            "@context": "https://schema.org",
            "@type": "Event",
            "name": event.name,
            "startDate": event.startDate,
            "endDate": event.endDate,
            "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
            "eventStatus": "https://schema.org/EventScheduled",
            "location": {
              "@type": "Place",
              "name": event.location.name,
              "address": {
                "@type": "PostalAddress",
                "streetAddress": event.location.streetAddress,
                "addressLocality": event.location.addressLocality,
                //"postalCode": event.location.postalCode,
                "addressRegion": event.location.addressRegion,
                "addressCountry": event.location.addressCountry || 'BR'
              }
            },
            "image": event.images,
            "description": event.description || event.name,
            "offers": {
              "@type": "Offer",
              "url": event.eventUrl,
              "availability": "https://schema.org/InStock",
            },
            "performer": {
              "@type": "PerformingGroup",
              "name": event.name
            },
            "organizer": {
              "@type": "Organization",
              "name": event.companyName,
              "url": event.companyUrl
            }
        };

		if(event.minPrice){
			schema.offers.price = event.minPrice;
			schema.offers.priceCurrency = 'BRL';
		}

		return schema;
	};

	static websiteSchema = (url?: string, name?: string) => {
		return {
			'@context': 'http://schema.org',
			'@type'      : 'WebSite',
			url          : url || 'https:\/\/google.com',
			name         : name || 'Google',
			"sameAs": ["https://facebook.com/google",
				   "https://instagram.com/google",
				   "https://twitter.com/google"]
			};
	};

	static orgSchema = () => ({
			'@context'  :
				'https://schema.org',
			'@type'     :
				'Organization',
			url         :
				'https://google.com',
			name        :
				'Google',
			contactPoint: {
				'@type'    :
					'ContactPoint',
				telephone  :
					'01293019413',
				contactType:
					'Customer service'
			}
		});

	constructor(@Inject(DOCUMENT) private _document: Document) {}

	removeStructuredData(): void {
		const els = Array();
		[ 'structured-data', 'structured-data-org' ].forEach((c:any) => {
			els.push(...Array.from(this._document.head.getElementsByClassName(c)));
		});
		els.forEach(el => this._document.head.removeChild(el));
	}

	insertSchema(schema: Record<string, any>, className = 'structured-data'): void {
		let script;
		let shouldAppend = false;
		if (this._document.head.getElementsByClassName(className).length) {
			script = this._document.head.getElementsByClassName(className)[0];
		} else {
			script = this._document.createElement('script');
			shouldAppend = true;
		}
		script.setAttribute('class', className);
		script.type = JsonLDService.scriptType;
		script.text = JSON.stringify(schema);
		if (shouldAppend) {
			this._document.head.appendChild(script);
		}
	}
}